(function() {
  const inventoryData = document.querySelector("#inventory-quantity")
  if (!inventoryData) return;
  
  const inventoryContent = inventoryData.textContent.trim();
  if (!isJson(inventoryContent)) return;
  const inventoryParsed = JSON.parse(inventoryContent);

  const deliveryInStockContainer = document.querySelector(".delivery_in_stock");
  const deliveryNoStockContainer = document.querySelector(".delivery_no_stock");
  const currentVariantID = inventoryParsed["currentVariant"];
  const addToCartText = inventoryParsed["addToCartText"];
  const preorderText = inventoryParsed["preorderText"];
  const soldOutText = inventoryParsed["soldOutText"];
  const bundleProductsSize = inventoryParsed["bundleProductsSize"].length || 0;

  const timeTranslations = document.querySelector(".countdown_digits");
  if (!timeTranslations) return;
  const translationHours = timeTranslations.dataset.countHours;
  const translationMinutes = timeTranslations.dataset.countMinutes;
  const translationSeconds = timeTranslations.dataset.countSeconds;

  const addToCartButton = document.querySelector("#AddToCart");
  const addToCartButtonText = document.querySelector("#AddToCart span");

  if (!deliveryInStockContainer || !deliveryNoStockContainer || !addToCartButton) {
    return;
  }

  function isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
  }

  function showDeliveryOptions(variantId, isInStock) {
    const { inventoryPolicy, preorder } = inventoryParsed[variantId];
    const isContinueselling = inventoryPolicy === "continue";
    const isPreorder = preorder === "true";

    if (isInStock) {
      deliveryInStockContainer.classList.remove("d-none");
      deliveryNoStockContainer.classList.add("d-none");
      addToCartButtonText.textContent = addToCartText;
    } else if (isPreorder && isContinueselling) {
      deliveryInStockContainer.classList.add("d-none");
      deliveryNoStockContainer.classList.add("d-none");
      addToCartButton.style.backgroundColor = "#000";
      addToCartButton.style.color = "#fff";
      addToCartButtonText.textContent = preorderText;
    } else if (!isPreorder && isContinueselling) {
      deliveryInStockContainer.classList.add("d-none");
      deliveryNoStockContainer.classList.remove("d-none");
      addToCartButtonText.textContent = addToCartText;
    } else if (!isContinueselling) {
      deliveryInStockContainer.classList.add("d-none");
      deliveryNoStockContainer.classList.add("d-none");
      addToCartButtonText.textContent = soldOutText;
    }
  };

  function renderShippingCountdown(event, currentVariantID) {
    const { variantsInventoryLevels, product: { product } } = event.detail;
    if (!variantsInventoryLevels) return;
    const currentVariant = variantsInventoryLevels.find(inventory => inventory.id.includes(currentVariantID));

    let isInStock = currentVariant.inventory_quantities.find(({ level }) => level > 0) ? true : false;
    // Check if product is bundle and if so, check if product quantity is greater than 0
    const currentVariantId = currentVariant.id;
    const isBundleInStock = product.variants.find(({ admin_graphql_api_id }) => admin_graphql_api_id === currentVariantId).inventory_quantity > 0;
    if (
      !isInStock && 
      bundleProductsSize >= 2 &&  
      isBundleInStock
    ) isInStock = true;
    showDeliveryOptions(currentVariantID, isInStock);
  }

  let deliveryCountdown = setInterval(function () {
    let currentTime = new Date();
    let dayOfWeek = currentTime.getDay();
    let isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

    if (isWeekend) {
      deliveryInStockContainer.querySelector('.countdown_timer').classList.add('d-none');
      return false;
    }

    let denmarkTime = new Intl.DateTimeFormat("en-US", {
      timeZone: "Europe/Copenhagen",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).format(currentTime);

    let [dkHours, dkMinutes, dkSeconds] = denmarkTime.split(":");

    let diffHour = 14 - dkHours;
    let diffMin = 59 - dkMinutes;
    let diffSec = 59 - dkSeconds;

    if (diffHour >= 0 && diffMin >= 0 && diffSec >= 0) {
      deliveryInStockContainer.querySelector(".countdown_digits").innerHTML = `
          ${diffHour}${translationHours}:
          ${diffMin}${translationMinutes}:
          ${diffSec}${translationSeconds}
      `;
      deliveryInStockContainer.querySelector(".countdown_timer").classList.remove("d-none");
      deliveryInStockContainer.querySelector(".countdown_expected").classList.add("d-none");
    } else {
      deliveryInStockContainer.querySelector(".countdown_timer").classList.add("d-none");
      deliveryInStockContainer.querySelector(".countdown_expected").classList.remove("d-none");
    }
  }, 1000);


  document.addEventListener("DOMContentLoaded", () => {
    if (!currentVariantID) return;

    function handleVariantStockOnLoad(event) {
      renderShippingCountdown(event, currentVariantID);
      document.removeEventListener('productAndVariantsInventoryOnLoad', handleVariantStockOnLoad, false);
    }
    document.addEventListener('productAndVariantsInventoryOnLoad', handleVariantStockOnLoad);
  });

  document.addEventListener("product:variant-change", function(e) {
    const variantId = e.detail.variant.id;
    if (!variantId) return;
    
    function handleVariantStockOnChange(event) {
      renderShippingCountdown(event, variantId);
      document.removeEventListener('productOnChange', handleVariantStockOnChange, false)
    }
    document.addEventListener('productOnChange', handleVariantStockOnChange)
  });
})();